export const PLAYLIST_TEST = 'PLAYLIST_TEST';
export const PLAYLIST_CLEAR = 'PLAYLIST_CLEAR';
export const PLAYLIST_APPEND = 'PLAYLIST_APPEND';
export const PLAYLIST_REPLACE = 'PLAYLIST_REPLACE';

export function playlistTest(songs) {
  return dispatch => {
    return dispatch({
      type: PLAYLIST_TEST
    });
  }
}

export function playlistClear() {
  return dispatch => {
    return dispatch({
      type: PLAYLIST_CLEAR
    });
  }
}

export function playlistAppend(songs) {
  return dispatch => {
    return dispatch({
      songs,
      type: PLAYLIST_APPEND
    });
  }
}

export function playlistReplace(songs) {
  return dispatch => {
    return dispatch({
      songs,
      type: PLAYLIST_REPLACE
    });
  }
}


// WEBPACK FOOTER //
// ./src/actions/PlaylistActions.js